import { hasProp } from '@/utils';

export const addError = (commit, error, explanation) => {
	error.explanation = explanation;
	if (!hasProp(error, 'closes')) {
		error.closes = true;
	}
	commit('maybeAddError', error, { root: true });
};
